import React from 'react';
import IntakeStartScreen from 'components/common/intakeStartScreen';
import MedicalHistoryApp from 'components/medicalHistory';

function MedicalHistoryStartScreen() {
  return (
    <IntakeStartScreen
      currentStep="medicalHistory"
      metaTitle="Add Medical History"
    >
      <MedicalHistoryApp />
    </IntakeStartScreen>
  );
}

export default MedicalHistoryStartScreen;
